const secondsTimeFormat = (seconds) => {
	
	if ( seconds < 3600 ) {
		return new Date( seconds * 1000 ).toUTCString().split(/ /)[4].substr(3);
	} 

	return new Date( seconds * 1000 ).toUTCString().split(/ /)[4];
}

export const initSharing = ( player, section ) => {

	const sharingButton = section.querySelector( '.video #open-share' );
	const playListSharingButton = section.querySelector( '.playlist #open-share' );
	const sharingPopUp = section.querySelector( '.sharing-menu' );

	if ( !sharingPopUp ) {
		return;
	}

	const mediaLinks = sharingPopUp.querySelectorAll( 'div a' );
	const timeInput = sharingPopUp.querySelector( 'input[type=text]' );
	const linkText = sharingPopUp.querySelector( '.link' );
	const timeCheckBox = sharingPopUp.querySelector( 'input[type=checkbox]' );
	const closeButton = sharingPopUp.querySelector( 'button.close' );
	const parameter = location.search ? '&time=' : '?time=';
	const copyLink = sharingPopUp.querySelector( '.links > button' );
	const playlistLink = '/video/?list=' + sharingPopUp.getAttribute('playlist-id');
	const defaultSocialLinks = [];
	const mainLink = location.href;
	let time;

	mediaLinks.forEach( item => {
		defaultSocialLinks.push(item.href);
	});

	const changeTime = (seconds) => {

		time = seconds > 0 ? parameter + seconds : '';
		
		mediaLinks.forEach( item => {
			item.href = item.href.split(parameter)[0] + time;
		});
		
		linkText.innerText = linkText.innerText.split(parameter)[0] + time;
	}

	const closeShare = () => {
		section.classList.remove( 'sharing-active' );
		sharingPopUp.classList.remove( 'active' );
		document.querySelector( 'html' ).style = 'overflow: visible';
		sharingPopUp.classList.remove('playlist-share');
		copyLink.classList.remove( 'copy-complete' );

		if ( timeCheckBox ) {
			timeCheckBox.checked = false;
		}
	}

	document.onkeydown = function(e) {
		if (e.keyCode == 27) {
			closeShare();
		}
	}

	const openShare = (linkToClipBoard) => {
		section.classList.add( 'sharing-active' );
		sharingPopUp.classList.add( 'active' );
		document.querySelector('html').style = 'overflow: hidden';
		
		if ( timeInput ) {
			timeInput.value = secondsTimeFormat(Math.round(player.currentTime()));
		}

		document.addEventListener( 'click', (e) => {
			if ( (!e.target.closest( '.sharing-menu' ) && e.target !== sharingButton && e.target !== playListSharingButton ) || e.target === closeButton) {
				closeShare();
			}

			if (!e.target.closest( 'div button' ) && copyLink.classList.contains( 'copy-complete' )) {
				copyLink.classList.remove( 'copy-complete' );
			}

			if ( e.target.closest( '.links > button' ) ) {
				const clipboardText = sharingPopUp.classList.contains('playlist-share') ? linkToClipBoard : linkToClipBoard + (time ? time : '')
				navigator.clipboard.writeText(clipboardText)
				copyLink.classList.add( 'copy-complete' );
			}
		})

		if ( timeInput ) {

			timeCheckBox.addEventListener( 'change', () => {
				if ( timeCheckBox.checked === false ) {

					mediaLinks.forEach( item => {
						item.href = item.href.split(parameter)[0];
					});

					linkText.innerText = linkText.innerText.split(parameter)[0];
				} 
				else 
				{
					changeTime(Math.round(player.currentTime()));
					timeInput.value = secondsTimeFormat(Math.round(player.currentTime()));
					linkText.innerText = linkText.innerText.split(parameter)[0] + time;
				}
			})

			timeInput.addEventListener( 'input', () => {

				timeInput.value = timeInput.value.replace(/[^:\d]/g, '');

				if ( timeInput.value.split(':').length - 1 > 2 ) {
					timeInput.value = timeInput.value.replace(/.$/, "");
				};
			});

			timeInput.addEventListener( 'change', () => {
				if ( timeInput.value.includes( ':' )) {
					let seconds = 0;

					if ( timeInput.value.split( ':' )[2] ) {
						seconds = timeInput.value.split( ':' )[0] * 3600 + timeInput.value.split( ':' )[1] * 60 + +timeInput.value.split( ':' )[2];
					} else {
						seconds = timeInput.value.split( ':' )[0] * 60 + +timeInput.value.split( ':' )[1];
					}

					changeTime(seconds);
					timeInput.value = secondsTimeFormat(seconds);
				} else 
				{
					changeTime(timeInput.value);
					timeInput.value = secondsTimeFormat(timeInput.value);
				}
			})
		}
	}
	
	sharingButton.addEventListener('click', () => {
		const parts = location.pathname
			.split('/')
			.filter(part => part !== '');

		const shortLink = parts.length === 3
			? location.href.replace(`/${parts[1]}`, '')
			: location.href;

		openShare(shortLink);
		linkText.innerText = shortLink.split('://')[1];
		
		mediaLinks.forEach( (item, index) => {
			item.href = defaultSocialLinks[index] + shortLink;
		});
	})

	if ( playListSharingButton ) {
		playListSharingButton.addEventListener('click', () => {
			openShare(mainLink.split('/video/')[0] + playlistLink);
			sharingPopUp.classList.add('playlist-share');
			linkText.innerText = mainLink.split('://')[1].split('/video/')[0] + playlistLink;
			
			mediaLinks.forEach( (item, index) => {
				item.href = defaultSocialLinks[index] + mainLink.split('/video/')[0] + playlistLink;
			});
		})
	}
}